<template lang="pug">
  div.text-center.align-middle.m-0(style="padding-top: 4px !important;")
    i.fas.fa-thumbtack.fa-2x(
      :class="isPinned ? 'text-primary' : 'text-secondary'",
      @click="switchPin"
      style="cursor: pointer;"
    )

</template>

<script>
import TagDomainApi from "../../apis/tag_domain";

export default {
  props: {
    tag_domain_id: Number,
    user_selected_domain_id: Number,
    domain: String,
  },
  data() {
    return {
      tagDomainId: this.tag_domain_id,
      isPinned: this.tag_domain_id == this.user_selected_domain_id,
    };
  },
  methods: {
    switchPin() {
      TagDomainApi.switch_pin({ domain: this.domain })
        .then((response) => {
          if (response.status === 201) {
            location.reload();
          } else {
            this.$toasted.error("更新に失敗しました");
          }
        })
        .catch((error) => {
          console.error(error);
          this.$toasted.error("エラーが発生しました");
        });
    },
  },
};
</script>

<style scoped>
.text-primary {
  color: #007bff !important;
}
.text-secondary {
  color: #e3e3e3 !important;
}
</style>
